
export default {
  created() {
    this.setError();
  },
  updated() {
    this.setError();
  },
  props: {
    value: {
      default: null
    },
    validate: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    verification: {
      type: Function,
      default: (val, required) => (required && val || !required ? true : false)
    }
  },
  data() {
    return {
      error: false,
      isValidated: null
    };
  },
  methods: {
    setError() {
      let isValidated = this.verification(this.value, this.required);
      this.error = this.validate && !isValidated;
      if (this.isValidated !== isValidated) {
        this.isValidated = isValidated;
        this.$emit('validated', this.isValidated);
      }
    }
  },
  destroyed() {
    this.$emit('validated', null);
  }
};